export default __webpack_public_path__ + "static/media/available-training-course.1822b4b5.svg";